import type { FC } from 'react';

import { LumappsComponentType } from '../../constants';
import type { LumappsComponentBaseProps, LumappsComponentProps } from '../../types';
import { AskAnswerComponent } from '../AskAnswerComponent';
import { FileListIntegrated } from '../FileListIntegrated';
import { FileListSettings } from '../FileListSettings';
import { IframeComponent } from '../IframeComponent';
import { UploadMediaIntegrated } from '../UploadMediaIntegrated';

type Component = FC<LumappsComponentProps>;
type SettingsComponent = FC<LumappsComponentBaseProps>;

/** A mapped list of components the Lumapps Components feature currently supports */
export const components: Record<
    LumappsComponentType,
    {
        component: Component;
        settings?: SettingsComponent;
        hasNextAction?: boolean;
    }
> = {
    [LumappsComponentType.AskAnswer]: {
        component: AskAnswerComponent as Component,
        settings: undefined,
    },
    [LumappsComponentType.FileList]: {
        component: FileListIntegrated as Component,
        settings: FileListSettings as SettingsComponent,
    },
    [LumappsComponentType.Uploader]: {
        component: UploadMediaIntegrated as Component,
        settings: undefined,
    },
    [LumappsComponentType.Iframe]: {
        component: IframeComponent as Component,
        settings: undefined,
        hasNextAction: false,
    },
};
